// Log out: the door on the left, the arrow leaving it (same direction as antd's LogoutOutlined). No rotation needed.
export const SidebarLogoutIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    focusable="false"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M9 20H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h3" />
    <path d="M16 16l4-4-4-4" />
    <path d="M20 12H10" />
  </svg>
);
